export default {
  sites: []
};
